// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/user/store'
import email from '@src/views/apps/email/store'
import invoice from '@src/views/apps/invoice/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'
import driver from  '@src/views/ukcb-views/driver/store'
import vehicle from  '@src/views/ukcb-views/vehicle/store'
import clients from  '@src/views/ukcb-views/client/store'
import passenger from  '@src/views/ukcb-views/passenger/store'
import staff from  '@src/views/ukcb-views/staff/store'
import vehicleType from  '@src/views/ukcb-views/vehicleType/store'
import clientType from  '@src/views/ukcb-views/client/store/clientType'
import driverType from  '@src/views/ukcb-views/driver/store/driverType'
import driverEarnings from  '@src/views/ukcb-views/driver/store/driverEarnings'
import driverPaymentModelAssignment from  '@src/views/ukcb-views/driverPaymentModelAssignment/store'
import clientPricingModelAssignment from  '@src/views/ukcb-views/clientPricingModelAssignment/store'
import driverBookingExpenses from  '@src/views/ukcb-views/driverBookingExpenses/store'
import bookingExpenseType from  '@src/views/ukcb-views/setting/store'
import commonLocation from '@src/views/ukcb-views/Common/store'
import pricing from '@src/views/ukcb-views/pricing/store'
import ReferenceClient from '@src/views/ukcb-views/client/store/ReferenceClient'
import ReferenceTag from '@src/views/ukcb-views/setting/tags/store/ReferenceTag'
import repeatBooking from '@src/views/ukcb-views/booking/store/repeatBooking'
import zone from '@src/views/ukcb-views/setting/store/zone'
import CCBooking from '../views/ukcb-views/passenger/store/CCBooking'
import booking from '../views/ukcb-views/booking/store'
import driverPayment from '../views/ukcb-views/driverPayments/store'
import clientInvoicing from '../views/ukcb-views/booking/ClientInvoicing/store'
import bookingValidation from '../views/ukcb-views/bookingValidation/store'
import creditCardBooking from '../views/ukcb-views/booking/store/creaditCardsBookings'
import stripeIntegration from '../views/ukcb-views/booking/store/stripeIntegration'
import DriverLocations from '../views/ukcb-views/Dispatch/store'
import DispatchBookings from '../views/ukcb-views/Dispatch/store/dispatchBookings'
import  TaxlistStore  from '../views/ukcb-views/setting/taxes/store'
import creditNoteStore from '../views/ukcb-views/invoicing/store'
import documentTypes from '../views/ukcb-views/setting/DocumentTypes/store'
import basicSettings from '../views/ukcb-views/setting/Company/store'
import providerSettings from '../views/ukcb-views/setting/ProviderSettings/store'
import emailSettings from '../views/ukcb-views/setting/EmailSettings/store'
import drvrPayment from '../views/ukcb-views/driverPayment/store'

import profileSettings from '../views/ukcb-views/setting/ProfileSettings/store'
import ukcbUser from '../views/ukcb-views/setting/Users/store'
import creditCard from '@src/views/ukcb-views/client/store/creditCards'
import cashBookings from '../views/ukcb-views/booking/CashBookings/store/CashBookings'
import cardTranscations from '../views/ukcb-views/invoicing/cardtransactions/store'
import Profitability from '../views/ukcb-views/profitability/store'
import knownLocation from '../views/ukcb-views/setting/KnownLocation/store'
import configuration from '../views/ukcb-views/setting/Configuration/store'
import DriverProfitability from '../views/ukcb-views/profitability/store/DriverProfitabilityStore'
import VehicleProfitability from '../views/ukcb-views/profitability/store/VehicleProfitabilityStore'
import UpcomingBooking from '../views/ukcb-views/Driver-App/UpcomingBookings/store'
import drivercreditCard from '@src/views/ukcb-views/driver/store/creditCards'
import permission from '@src/views/ukcb-views/Permissions/store'
import driverProfile from '../views/ukcb-views/Driver-App/DriverProfile/store'
import updatedriver from '../views/ukcb-views/Driver-App/DriverProfile/store/update'
import DriverStatusDashboardSlice from '../views/ukcb-views/Driver-App/DriverStatusDashboard/store'
import DriverJourney from '../views/ukcb-views/Driver-App/Journey/store'
import DriverNavBar from '../views/ukcb-views/Driver-App/DriverAppNavbar/store'
import DriverExpensesStore from '../views/ukcb-views/Driver-App/DriverExpenses/store'
import DriverDashboardSlice from '../views/ukcb-views/Driver-App/DriverDashboard/store'
import UserDropDownStoreSlice from '../../src/@core/layouts/components/navbar/store/UserDropDownStore'
import dashboardBookingsGraph from '../views/ukcb-views/dashboard/store'
import PassengerScreen from '../views/ukcb-views/PassengerScreen/store'
import appBooker from '../views/ukcb-views/Common/Booker/add/store'
import LogoutSlice from '../views/ukcb-views/Logout/store'
import IncidentLog from '../views/ukcb-views/incident/store'
import driverEvents from '../views/ukcb-views/dashboard/DriverCalendar/store'
import reports from '../views/ukcb-views/reports/store'
import appStripeSlice from '../views/ukcb-views/StripePayments/store'
const rootReducer = {
  
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  driver,
  vehicle,
  clients,
  passenger,
  staff,
  clientType,
  vehicleType,
  driverType,
  driverPaymentModelAssignment,
  clientPricingModelAssignment,
  driverBookingExpenses,
  bookingExpenseType,
  pricing,
  ReferenceClient,
  ReferenceTag,
  repeatBooking,
  zone,
  commonLocation,
  booking,
  driverEarnings,
  driverPayment,
  clientInvoicing,
  CCBooking,
  bookingValidation,
  creditCardBooking,
  stripeIntegration,
  DriverLocations,
  DispatchBookings,
  TaxlistStore,
  creditNoteStore,
  documentTypes,
  basicSettings,
  providerSettings,
  emailSettings,
  drvrPayment,
  ukcbUser,
  creditCard,
  cashBookings,
  cardTranscations,
  Profitability,
  DriverProfitability,
  VehicleProfitability,
  knownLocation,
  configuration,
  UpcomingBooking,
  drivercreditCard,
  permission,
  driverProfile,
  updatedriver,
  profileSettings,
  DriverStatusDashboardSlice,
  DriverJourney,
  DriverNavBar,
  DriverExpensesStore,
  DriverDashboardSlice,
  UserDropDownStoreSlice,
  dashboardBookingsGraph,
  PassengerScreen,
  appBooker,
  LogoutSlice,
  IncidentLog,
  driverEvents,
  reports,
  appStripeSlice
}

export default rootReducer